import AttributeSelectorComponent from '@intercom/embercom-composer/components/attribute-selector';
export default AttributeSelectorComponent;
